import { Path, Svg, SVGProps } from "@react-pdf/renderer";

export const WorkIcon = (props: SVGProps) => (
  <Svg {...props} viewBox="0 0 28 28">
    <Path
      d="M10.795 10.7076V9.88329C10.795 8.06221 12.2295 6.58594 13.999 6.58594C15.7685 6.58594 17.203 8.06221 17.203 9.88329V10.7076M6.79004 14.005L13.3484 17.0047C13.7626 17.1942 14.2354 17.1942 14.6497 17.0047L21.208 14.005M9.35323 21.424H18.6448C19.542 21.424 19.9906 21.424 20.3333 21.2443C20.6347 21.0862 20.8798 20.834 21.0334 20.5238C21.208 20.1711 21.208 19.7095 21.208 18.7861V13.3455C21.208 12.4222 21.208 11.9605 21.0334 11.6078C20.8798 11.2976 20.6347 11.0454 20.3333 10.8873C19.9906 10.7076 19.542 10.7076 18.6448 10.7076H9.35323C8.45603 10.7076 8.00743 10.7076 7.66474 10.8873C7.36331 11.0454 7.11824 11.2976 6.96465 11.6078C6.79004 11.9605 6.79004 12.4222 6.79004 13.3455V18.7861C6.79004 19.7095 6.79004 20.1711 6.96465 20.5238C7.11824 20.834 7.36331 21.0862 7.66474 21.2443C8.00743 21.424 8.45603 21.424 9.35323 21.424Z"
      fill="none"
      strokeWidth="1.64867"
      strokeLinecap="round"
    />
  </Svg>
);
